// Renders a "FIG.NN" stat overlaid on a 50-state grid mini-map.
// Stays in the same Swiss/blueprint design language used everywhere else.
const STATES = [
  "AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD",
  "MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC",
  "SD","TN","TX","UT","VT","VA","WA","WV","WI","WY",
];

export default function FigureOnMap({ figure, figId = "FIG.07", testId = "service-figure" }) {
  if (!figure) return null;

  // Hash slug-ish input to deterministically "highlight" some states for visual texture
  const seed = (figure.value + figure.unit).split("").reduce((s, c) => s + c.charCodeAt(0), 0);
  const highlighted = new Set();
  for (let i = 0; i < 18; i++) {
    highlighted.add(STATES[(seed * (i + 7)) % STATES.length]);
  }

  return (
    <div
      className="border border-zinc-900 bg-white p-6 md:p-8 relative overflow-hidden"
      data-testid={testId}
    >
      <div className="flex items-center justify-between text-[10px] uppercase tracking-[0.25em] font-mono text-zinc-500 pb-4 mb-4 border-b border-dashed border-zinc-300">
        <span>By the numbers</span>
        <span>{figId}</span>
      </div>

      <div className="grid grid-cols-12 gap-4 items-center">
        <div className="col-span-12 md:col-span-5">
          <div className="font-display text-6xl md:text-7xl tracking-tighter leading-none text-zinc-950">
            {figure.value}
          </div>
          <div className="mt-2 text-sm text-zinc-700 font-medium">{figure.unit}</div>
          <div
            className="mt-1 text-[11px] font-mono uppercase tracking-[0.2em] text-zinc-500"
            dangerouslySetInnerHTML={{ __html: figure.caption || "" }}
          />
          <div className="mt-5 inline-flex items-center gap-2 text-[10px] font-mono uppercase tracking-[0.25em] text-[#0044FF]">
            <span className="inline-block w-2 h-2 bg-[#0044FF]" />
            USA · 50 states active
          </div>
        </div>

        <div className="col-span-12 md:col-span-7">
          <div className="grid grid-cols-10 gap-1.5">
            {STATES.map((s) => {
              const on = highlighted.has(s);
              return (
                <div
                  key={s}
                  className={`aspect-square border flex items-center justify-center text-[8px] font-mono transition-colors ${
                    on
                      ? "bg-[#0044FF] border-[#0044FF] text-white"
                      : "bg-white border-zinc-200 text-zinc-400 hover:border-zinc-400"
                  }`}
                  title={s}
                >
                  {s}
                </div>
              );
            })}
          </div>
          <div className="mt-3 pt-3 border-t border-dashed border-zinc-200 flex items-center justify-between text-[10px] font-mono uppercase tracking-[0.2em] text-zinc-500">
            <span>Active states</span>
            <span>50 / 50</span>
          </div>
        </div>
      </div>
    </div>
  );
}
